import "core-js/modules/es.array.map.js";
import { contextualizeAuthor } from '../models';
export var profilesLayers = [{
  id: 'Profile',
  type: 'view',
  action: 'profile',
  name: 'profile',
  event: true,
  contextualize: function contextualize(_ref) {
    var profile = _ref.profile;
    return contextualizeAuthor(profile);
  }
}, {
  id: 'AdviserDM',
  type: 'click',
  action: 'sendMessage',
  name: 'sendMessage',
  event: true,
  contextualize: function contextualize(_ref2) {
    var adviser = _ref2.adviser,
      variant = _ref2.variant;
    return {
      adviser: adviser,
      variant: variant
    };
  }
}, {
  id: 'ProductRelatedAdvisers',
  type: 'impressions',
  name: 'advisers',
  model: 'adviser',
  modelize: function modelize(_ref3) {
    var models = _ref3.models;
    return models.map(function (item) {
      return contextualizeAuthor(item);
    });
  },
  contextualize: function contextualize(_ref4) {
    var variant = _ref4.variant;
    return {
      variant: variant
    };
  }
}];